import { Controller } from '@hotwired/stimulus';
import { Datepicker } from 'flowbite-datepicker';

export default class extends Controller {
  static targets = ['input'];

  inputTargetConnected() {
    this.picker = new Datepicker(this.inputTarget, {
      orientation: 'bottom',
      format: 'yyyy-mm-dd',
      autohide: true,
      minDate: new Date(),
      todayHighlight: true,
    });
  }
}
